<template>
  <v-container fluid tag="section">
      <v-stepper v-model="stepper" v-if="!waitingAffiliationApprove && !isAffiliated">
        <v-stepper-header>
          <v-stepper-step :step="1" :editable="stepper >= 1" :complete="stepper > 1">{{
            $t("select_affiliation_type")
          }}</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :step="2" :editable="stepper >= 2" :complete="stepper > 2">{{ $t("exec_payment")
          }}</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content :step="1">
         
            <v-row >
              <v-col cols="12" class="text-center">
                <v-select v-model="asdAffiliazione" :items="affilationList" item-value="affiliazione" item-text="descr"
                  :menu-props="{ maxHeight: '400' }" :label="$t('select_affiliation_type')" required color="primary"
                  persistent-hint></v-select>
              </v-col>
              <v-col cols="12">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th>{{ $t("image") }}</th>
                      <th>{{ $t("name") }}</th>
                      <th>
                        <div class="text-right">{{ $t("price") }}</div>
                      </th>
                    </tr>
                  </thead>

                  <tbody v-if="selectedAffiliazione">
                    <tr v-for="tessera in selectedAffiliazione.tessere" v-bind:key="tessera.tesId">
                      <td>
                        <div class="text-left">
                          <img style="height: 50px" :src="tessera.imgTessera" />
                        </div>
                      </td>
                      <td>
                        <div class="text-left">
                          <h3 :style="'color: ' + tessera.hexColor + ';'">
                            {{ tessera.nome }}
                          </h3>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">{{ tessera.prezzo }}</div>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn @click="gotoStep2" color="success">{{
                  $t("confirm_choise")
                }}</v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content :step="2">
            <v-row>
              <v-col cols="12">
                <select-mod-pag :riepilogo="riepilogo" @selected="confirmOrder"></select-mod-pag>
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <div v-else-if="!isAffiliated" class="mx-auto" max-width="400">
        <v-img class="white--text align-end" height="200px" src="/API/public/portal/getImage/THEME/login">
        </v-img>
        <v-card-title>{{ $t("data_waiting_for_approvation") }}</v-card-title>

        <v-card-text class="text--primary">
          <v-card-subtitle class="pb-0">
            {{ asdAffiliazione }}
          </v-card-subtitle>
        </v-card-text>
      </div>

      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">
              {{ $t("confirm_order") }}
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>{{ $t("beneficiary") }}</td>
                    <td>{{ enteData.ragSoc }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("type") }}</td>
                    <td>
                      {{
                        isAffiliated
                        ? $t("affiliation_cards")
                        : $t("ente_affiliation")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("total") }}</td>
                    <td>{{ riepilogo.totale }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("payment_date") }}</td>
                    <td>
                      {{
                        params.dataPag
                        ? new Date(params.dataPag).toLocaleDateString("it")
                        : new Date().toLocaleDateString("it")
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog = false">
                {{ $t("undo") }}
              </v-btn>
              <v-btn color="green darken-1" text @click="sendOrder">
                {{ $t("confirm") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <profile-page @isUpdated="loadTable" ref="userProfileDialog"></profile-page>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import profilePage from "@/app/UserProfile.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import selectModPag from "@/widget/selectModPag.vue";

import Swal from "sweetalert2";
import moment from "moment";

let _ = this;
export default {
  name: "affiliazione-MYASD",
  components: {
    DataTables,
    profilePage,
    MyDatepicker,
    selectModPag,
  },
  data() {
    return {
      files: [],
      listUpdated: null,
      listError: null,
      dateInz: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      dateEnd: new Date(),
      dialog: false,
      isAffiliated: false,
      waitingAffiliationApprove: false,
      priceAffiliation: 0,
      affilationList: [],
      asdAffiliazione: null,
      riepilogo: {
        headers: [
          { text: this.$t("item"), value: "item" },
          { text: this.$t("qta"), value: "qta" },
          { text: this.$t("price"), value: "prezzo" },
          { text: this.$t("total"), value: "total" },
        ],
        items: [],
        totale: 0,
      },
      stepper: 1,
      params: {
        pagId: null,
        asdAffiliazione: null,
        dettaglio: [],
      },
      selected: [],
      headers: [
        { text: this.$t("avatar"), value: "avatarUrl", type: "image" },
        { text: this.$t("surname"), value: "surname" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("email"), value: "email" },
        { text: this.$t("residence_address"), value: "resCity" },
        { text: this.$t("telephone"), value: "telephone" },
        { text: this.$t("eta"), value: "eta", type: "numeric" },
        { text: this.$t("card"), value: "tesseraImage", type: "image" },
        {
          text: this.$t("type_affiliation_card_ente"),
          value: "tesseraEnte",
          type: "html",
        },
        { text: this.$t("price"), value: "prezzo", type: "number" },
        { text: this.$t("date_affiliation"), value: "dateTes", type: "date" },
        { text: this.$t("status"), value: "status", type: "icons" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    sendOrder: function (data) {
      let _ = this;
      _.dialog = false;
      _.chiamataAxios(
        "POST",
        _.isAffiliated
          ? "/auth/ente/buyEnteTessere/"
          : "/auth/ente/buyAffiliazione/",
        { dialogLoader: true, body: _.params }
      ).then((response) => {
        Swal.fire({
          type: response.msg.esito ? "success" : "error",
          title: response.msg.esito
            ? _.$t("operation_successfully_completed")
            : _.$t("there_was_an_error"),
          html: response.msg.msgTxt,
        });

        if (response.msg.esito) _.$router.push("/portal/");
      });
    },
    confirmOrder: function (data) {
      this.params.pagId = data.pagId;
      this.params.dataPag = data.dataPag;
      this.params.dexPag = data.title;
      this.dialog = true;
    },
    gotoStep2: function () {
      let _ = this;
      _.riepilogo.totale = 0;
      _.riepilogo.items = [];
      _.params = {
        pagId: null,
        asdAffiliazione: null,
        dettaglio: [],
      };
      // Prepara ordine e riepilogo
      if (_.isAffiliated) {
        let aggregato = [];
        for (let utente of _.tableData) {
          if (_.selected.includes(utente.key)) {
            if (!aggregato[utente.asdTesId + "_" + utente.prezzo]) {
              aggregato[utente.asdTesId + "_" + utente.prezzo] = {
                tesId: utente.asdTesId,
                item: utente.asdTesTipo,
                image: utente.tesseraImage,
                prezzo: utente.prezzo,
                qta: 0,
              };
            }
            _.params.dettaglio.push(utente.key);
            aggregato[utente.asdTesId + "_" + utente.prezzo].qta += 1;
          }
        }
        for (let tesId in aggregato) {
          _.riepilogo.totale += aggregato[tesId].prezzo * aggregato[tesId].qta;
          _.riepilogo.items.push({
            item: aggregato[tesId].item,
            qta: aggregato[tesId].qta,
            prezzo: aggregato[tesId].prezzo,
            total: aggregato[tesId].prezzo * aggregato[tesId].qta,
          });
        }
        if (_.selected.length > 0) _.stepper = 2;
      } else {
        if (_.asdAffiliazione) {
          _.params.asdAffiliazione = _.asdAffiliazione;
          _.riepilogo.totale = _.selectedAffiliazione.prezzo;
          _.riepilogo.items.push({
            item: _.asdAffiliazione,
            qta: 1,
            prezzo: _.selectedAffiliazione.prezzo,
            total: _.selectedAffiliazione.prezzo,
          });
          _.stepper = 2;
        }
      }
    },
    showUser(item) {
      this.$refs.userProfileDialog.open(item.id, 4);
    },
    loadTable() {
      let _ = this;
      _.tableData = [];
      _.isFetching = true;
      _.isAffiliated = false;
      _.chiamataAxios("GET", "/auth/ente/getListinoTessere").then(
        (response) => {
          _.isAffiliated = response.data.affiliated;
          _.waitingAffiliationApprove = response.data.waitingAffiliationApprove;
          _.affilationList = response.data.affilationList;
          _.asdAffiliazione = response.data.asdAffiliazione;
          if (_.isAffiliated)
            _.chiamataAxios(
              "GET",
              "/auth/tesseramenti/listUser2affiliate"
            ).then((response) => {
              _.tableData = response.data.map(function (item) {
                item.tesseraEnte =
                  '<h4 style="color: ' +
                  item.asdTesHexColor +
                  ';">' +
                  item.asdTesTipo +
                  "</h4>";

                item.options = [
                  {
                    icon: "mdi-magnify",
                    color: "primary",
                    function: "showUser",
                  },
                ];
                if (item.waitingApproval) {
                  item.disabled = true;
                  item.status = [
                    {
                      icon: "mdi-clock-time-three-outline",
                      color: "warning",
                      text: _.$t("data_waiting_for_approvation"),
                    },
                  ];
                } else item.status = null;

                return item;
              });

              _.isFetching = false;
            });
        }
      );
    },
  },
  created() {
    this.loadTable();
  },
  computed: {
    selectedAffiliazione: function () {
      let _ = this;
      let curAffiliazione = _.affilationList.filter((item) => {
        return item.affiliazione === _.asdAffiliazione;
      });
      if (curAffiliazione.length !== 1) return null;

      return curAffiliazione[0];
    },

    enteData: function () {
      return window.systemData.ente;
    },
  },
};
</script>

